export const actionCreator = (type) => {
  return (value) => ({type, value})
}



// WEBPACK FOOTER //
// ./src/actions/helpers.js